import { render } from "./TeamDeliveries.vue?vue&type=template&id=28e78d84"
import script from "./TeamDeliveries.vue?vue&type=script&lang=js"
export * from "./TeamDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__